import { Sparkle28Filled } from "@fluentui/react-icons";
import kognifyLogo from "../../assets/kognifyLogo.png";
export const AnswerIcon = () => {
    return <img src={kognifyLogo} height={30} width={28} style={{ marginBottom: "-5px", zIndex: 2 }} />;
};
